import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import API from "../../actions";
import ErrorMessage from "../Alerts/ErrorMessage.js";
import SuccessMessage from "../Alerts/SuccessMessage.js";
import { Button } from "@material-ui/core";

export default props => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
    const [errorPasswordMatch, setErrorPasswordMatch] = useState(false);
    const [errorOldPassword, setErrorOldPassword] = useState(false);
    const [errorEmpty, setErrorEmpty] = useState(false);
    const [passwordSaved, setPasswordSaved] = useState(false);

    props.setLocationName();

    return (
        <Container maxWidth="md">
            <TextField
                key="oldPassword"
                label="Nuværende Password"
                InputLabelProps={{ shrink: true }}
                type="password"
                value={oldPassword}
                onChange={event => setOldPassword(event.target.value)}
                style={{ margin: "10px auto 10px auto", width: "100%" }}
            />
            <TextField
                key="newPassword"
                label="Nyt Password"
                InputLabelProps={{ shrink: true }}
                type="password"
                value={newPassword}
                onChange={event => setNewPassword(event.target.value)}
                style={{ margin: "10px auto 10px auto", width: "100%" }}
            />
            <TextField
                key="newPasswordConfirm"
                label="Nyt Password (gentag)"
                InputLabelProps={{ shrink: true }}
                type="password"
                value={newPasswordConfirm}
                onChange={event => setNewPasswordConfirm(event.target.value)}
                style={{ margin: "10px auto 10px auto", width: "100%" }}
            />
            <Button
                variant="contained"
                type="button"
                style={{ margin: "10px 0 10px 0", fontFamily: "Lato", float: "right" }}
                onClick={async event => {
                    event.preventDefault();
                    if (!oldPassword || !newPassword || !newPasswordConfirm) {
                        setErrorEmpty(true);
                        return;
                    }
                    if (newPassword !== newPasswordConfirm) {
                        setErrorPasswordMatch(true);
                        return;
                    }
                    API.setPassword(oldPassword, newPassword).then(
                        () => setPasswordSaved(true),
                        err => setErrorOldPassword(true)
                    );
                }}>
                Skift password
            </Button>
            <ErrorMessage
                open={errorPasswordMatch}
                handleClose={() => setErrorPasswordMatch(false)}
                text="De to nye passwords matcher ikke"
            />
            <ErrorMessage
                open={errorOldPassword}
                handleClose={() => setErrorOldPassword(false)}
                text="Forkert oprindeligt password"
            />
            <ErrorMessage open={errorEmpty} handleClose={() => setErrorEmpty(false)} text="Alle felter skal udfyldes" />
            <SuccessMessage
                open={passwordSaved}
                handleClose={() => setPasswordSaved(false)}
                text="Nyt password gemt!"
            />
        </Container>
    );
};
